import { injectIntl } from 'react-intl';
import ESignFail from './ESignFail';
import config from './config';

export const CONFIG = config;

export default injectIntl(ESignFail);
